import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetStudentOutput, StudentProgramEnrollment } from '../../API.service';
import { StudentState } from '../states';

@Injectable()
export class StudentFacade {
  programEnrollments$: Observable<StudentProgramEnrollment[] | null>;
  student$: Observable<GetStudentOutput | null> = this.studentState.student$;
  studentId$: Observable<string | null>;
  studentLoading$: Observable<boolean>;

  constructor(private readonly studentState: StudentState) {
    this.programEnrollments$ = this.studentState.student$.pipe(
      map(
        (student: GetStudentOutput | null) =>
          student?.program_enrollments.sort((a, b) => a.programKey.localeCompare(b.programKey)) || null
      )
    );
    this.studentId$ = this.studentState.student$.pipe(
      map((student: GetStudentOutput | null) => student?.student_id || null)
    );
    this.studentLoading$ = this.studentState.student$.pipe(map((student: GetStudentOutput | null) => !student));
  }
}
